module.exports = __webpack_public_path__ + "img/bg-md.55a42ef.jpg";